import React, { FC, Fragment, useEffect, useRef, useState } from 'react';
import * as THREE from 'three';
import { STLLoader } from 'three/examples/jsm/loaders/STLLoader';
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js';
import { SimplifyModifier } from 'three/examples/jsm/modifiers/SimplifyModifier.js';
import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';

type StlViewerProps = {
    url: string;
    open: boolean;
    onClose?: () => void;
};
// TODO: REFACTORING!! Only prototype
const StlViewer: FC<StlViewerProps> = ({ url, open, onClose }: StlViewerProps) => {
    const [loading, setLoading] = useState(true);
    const cancasRef = useRef<HTMLCanvasElement | null>(null);
    const cancasWrapperRef = useRef<HTMLDivElement | null>(null);

    const width = window.innerWidth - 500;
    const height = window.innerHeight - 230;
    const distance = 10000;

    useEffect(() => {
        const scene = new THREE.Scene();
        if (open) {
            setLoading(true);
            if (cancasRef.current) {
                cancasWrapperRef.current?.removeChild(cancasRef.current);
            }
            const simplify = new SimplifyModifier();

            const camera = new THREE.PerspectiveCamera(30, width / height, 1, distance);
            scene.add(camera);

            const renderer = new THREE.WebGLRenderer({
                precision: 'lowp',
                preserveDrawingBuffer: true,
                antialias: true,
                //canvas: cancasRef.current as HTMLCanvasElement,
            });
            cancasRef.current = renderer.domElement;
            renderer.setSize(width, height);
            renderer.setClearColor('#222222', 1);

            const render = () => {
                renderer.render(scene, camera);
            };

            const controls = new OrbitControls(camera, renderer.domElement);
            controls.enabled = true;
            controls.enablePan = false;
            controls.enableZoom = true;
            controls.addEventListener('change', render);

            const onLoad = (geometry: any) => {
                console.log(geometry);
                const simplifiedGeo = simplify.modify(geometry, 1000);
                simplifiedGeo.computeVertexNormals();
                simplifiedGeo.center();
                const mesh = new THREE.Mesh(
                    simplifiedGeo,
                    new THREE.MeshLambertMaterial({
                        color: 0xffffff,
                    }),
                );
                geometry.computeBoundingBox();
                const xDims = geometry.boundingBox.max.x - geometry.boundingBox.min.x;
                const yDims = geometry.boundingBox.max.y - geometry.boundingBox.min.y;
                const zDims = geometry.boundingBox.max.z - geometry.boundingBox.min.z;
                scene.add(mesh);
                const maxDims = Math.max(xDims * 3, yDims * 3, zDims * 3);
                camera.position.set(0, 0, maxDims);
                controls.maxDistance = maxDims * 2;
                controls.minDistance = maxDims * 0.25;
                controls.update();

                cancasWrapperRef.current?.appendChild(renderer.domElement);

                render();
                setLoading(false);
            };

            const directionalLight = new THREE.DirectionalLight(0xffffff, 1.3);
            directionalLight.position.x = 0;
            directionalLight.position.y = 1;
            directionalLight.position.z = 1;
            directionalLight.position.normalize();
            scene.add(directionalLight);

            const directionalLight2 = new THREE.DirectionalLight(0xffffff, 1.3);
            directionalLight2.position.x = 1;
            directionalLight2.position.y = 1;
            directionalLight2.position.z = 0;
            directionalLight2.position.normalize();
            scene.add(directionalLight2);

            const ambientLight = new THREE.AmbientLight(0xf0f0f0); // soft white light
            scene.add(ambientLight);

            const loader = new STLLoader();
            console.log('LOAD URL: ' + url);
            loader.load(url, onLoad);
        }
        return () => {
            scene.clear();
        };
    }, [open]);

    return (
        <Fragment>
            <Dialog open={open} maxWidth="xl" onClose={onClose}>
                <DialogTitle>STL</DialogTitle>
                <DialogContent>
                    <div
                        ref={cancasWrapperRef}
                        style={{
                            width: width,
                            height: height,
                            background: '#222222',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}
                    >
                        {loading ? (
                            <CircularProgress size={80} color="inherit" disableShrink sx={{ color: '#fff' }} />
                        ) : undefined}
                    </div>
                </DialogContent>
                <DialogActions sx={{ justifyContent: 'center' }}>
                    <Button onClick={onClose} variant="contained">
                        Stäng
                    </Button>
                </DialogActions>
            </Dialog>
        </Fragment>
    );
};

export default StlViewer;
